import React from "react"
import Litepicker from 'litepicker';
import moment from 'moment';

export default class DateSelector extends React.Component {
	
	constructor(props) {
		super(props);

		this.datePickerRef = React.createRef()
	}

	componentDidMount() {
		var self = this;

		this.datepicker = new Litepicker({
			autoclose: true,
      singleMode: false,
			startDate: this.props.startDate,
			endDate: this.props.endDate,
	    element: this.datePickerRef.current,
	    footer: false,
	    format: 'MM/DD/YYYY',
      maxDays: 90,
	    numberOfColumns: 2,
	    numberOfMonths: 2,
	    hoveringTooltip: false,
		});

    this.datepicker.on('selected', (start, end) => {
      var startDate = moment(start.dateInstance);
      var endDate = moment(end.dateInstance);

      if (!endDate.isValid()) {
        endDate = null
      }

      self.props.onChangeDates(startDate, endDate)
    });
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.startDate && this.props.endDate && (!this.props.startDate.isSame(prevProps.startDate, 'day') || !this.props.endDate.isSame(prevProps.endDate, 'day'))) {
			this.datepicker.setDateRange(this.props.startDate, this.props.endDate, true)
		}
	}

	render() {
    // console.log('DateSelector', this.props)
		return (
			<div className="DateSelector">
				<form className="form-inline">
					<select className="form-control" name="dateRange" onChange={this.props.onChange} value={this.props.dateRange}>
            {/*<option value="30">{I18n.t('admin.last_7_days')}</option>*/}
            <option value="30">{I18n.t('admin.last_30_days')}</option>
						<option value="60">{I18n.t('admin.last_60_days')}</option>
						<option value="90">{I18n.t('admin.last_90_days')}</option>
						<option value="custom">{I18n.t('admin.custom')}</option>
					</select>
					<input type="text" name="date" ref={this.datePickerRef} className="form-control" readOnly={true} />
				</form>
			</div>
		)
	}

}